import { createContext, useContext, useEffect, useState } from "react";
import userModel from "../model/user.model";


const ContactContext = createContext();


export const ContactProvider = ({ children }) => {
  const [contact, setContact] = useState("");
  const [search, setSearch] = useState();
  const[userdata,setuserdata]=useState();

    const GetUser =async()=>{
    userModel.Get()
    .then((responce)=>{
      setuserdata(responce?.data)
    })
    .catch((error)=>{
      console.log("error",error)
    })
  }
  
useEffect(()=>{
GetUser();
},[])
console.log("fffff456",userdata)
  return (
    <ContactContext.Provider value={{ contact, setContact, search, setSearch,GetUser,userdata}}>
      {children}
    </ContactContext.Provider>
  );
};


export const useContact = () => useContext(ContactContext);